export default "__VITE_ASSET__Ca1BxttI__"